exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".component.simplecarousel {\n  width: auto;\n  max-width: 40rem;\n  display: block;\n  margin: 0 auto;\n  position: relative; }\n  .component.simplecarousel img {\n    opacity: 0;\n    transition: opacity 0.2s ease-in-out;\n    position: absolute;\n    top: 0;\n    left: 0; }\n    .component.simplecarousel img[data-visible=\"true\"] {\n      opacity: 1; }\n    .component.simplecarousel img:first-child {\n      position: relative; }\n  .component.simplecarousel[data-transition=\"true\"] img {\n    opacity: 0; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/simplecarousel/simplecarousel.scss
// module id = 192
// module chunks = 0